<template>
  <div>
    <StoreSwitcher v-if="isAdmin" />
    <PeriodReportFilter v-model="filter" @filter="loadReport" />
    <PeriodReportList
      :items="reportItems"
      :loading="isRpLoading"
      @refresh="loadReport"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import services from '@/services'
import StoreSwitcher from '@/components/Stores/StoreSwitcher'
import PeriodReportList from './PeriodReportList.vue'
import PeriodReportFilter from './PeriodReportFilter.vue'

// Normaliza qualquer coisa (Date|string) para 'YYYY-MM-DD'
const toYMD = (d) => {
  if (!d) return null
  if (typeof d === 'string') {
    // já vem 'YYYY-MM-DD' do datepicker? então só corta
    if (/^\d{4}-\d{2}-\d{2}/.test(d)) return d.slice(0, 10)
    // caso venha 'DD/MM/YYYY'
    const m = d.match(/^(\d{2})\/(\d{2})\/(\d{4})/)
    if (m) return `${m[3]}-${m[2]}-${m[1]}`
  }
  try {
    return new Date(d).toISOString().slice(0, 10)
  } catch {
    return null
  }
}

export default {
  name: 'ByPeriodReport',
  components: { StoreSwitcher, PeriodReportFilter, PeriodReportList },

  data() {
    const today = toYMD(new Date()) // ✅ já inicia correto
    return {
      loading: { rp: false },
      filter: { fromDate: today, toDate: today, groupBy: 'day' },
      rp: []
    }
  },

  computed: {
    ...mapGetters('store', ['currentStoreId', 'isAdmin']),
    reportItems() {
      console.log('reportItems:', this.rp)
      return Array.isArray(this.rp) ? this.rp : []
    },
    isRpLoading() {
      return (this.loading && this.loading.rp) || false
    }
  },

  created() {
    this.loadReport()
  },

  methods: {
    async loadReport() {
      const storeId = Number(this.currentStoreId)
      const fromDate = toYMD(this.filter.fromDate)
      const toDate = toYMD(this.filter.toDate)
      const { groupBy } = this.filter

      this.loading.rp = true
      try {
        const data = await services.reports.fetchPeriodsReport({
          storeId,
          fromDate,
          toDate,
          groupBy
        })
        console.log('Dados recebidos:', data)
        this.rp = Array.isArray(data)
          ? data
          : Array.isArray(data?.data)
          ? data.data
          : []
      } catch (e) {
        console.error('Erro ao carregar periodRents:', e)
        this.rp = []
      } finally {
        this.loading.rp = false
      }
    }
  }
}
</script>
